export const FALLBACK_LOGO_URL = "/img/readdy/d6b4e0a5eace.webp";

const AVATAR_COLORS = [
  '#C4926E',
  '#A0855B',
  '#D4956A',
  '#B8866A',
  '#C47A7A',
  '#8B7355',
  '#9B7B5C',
  '#BF8A6E',
];

export function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return (parts[0]?.slice(0, 2) || '?').toUpperCase();
}

export function getAvatarColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export type PhotoPosition = "top" | "center" | "bottom";

// Normaliza o valor salvo no banco pra um dos três pontos focais válidos.
// Qualquer coisa que não seja center/bottom cai em 'top' (padrão atual).
export function normalizePhotoPosition(value: string | null | undefined): PhotoPosition {
  if (value === "center" || value === "bottom") return value;
  return "top";
}

// Mapa pra classe Tailwind de object-position correspondente.
export const PHOTO_POSITION_CLASS: Record<PhotoPosition, string> = {
  top: "object-top",
  center: "object-center",
  bottom: "object-bottom",
};

export const PHOTO_POSITION_OPTIONS: { value: PhotoPosition; label: string; icon: string }[] = [
  { value: "top", label: "Topo", icon: "ri-arrow-up-line" },
  { value: "center", label: "Centro", icon: "ri-subtract-line" },
  { value: "bottom", label: "Base", icon: "ri-arrow-down-line" },
];